import styled from "styled-components";
import ImgArrow from "@/styles/assets/svg/icon_select_arrow.svg";

export const SelectBox = styled.div`
  width: 100%;
  display: flex;
  font-size: 1.4rem;
  background: ${(props) => props.theme.colors.white100};

  &:focus {
    border: 2px solid ${(props) => props.theme.colors.primary100};
    outline: none;
  }
`;

export const Select = styled.select<{ hasValue: boolean }>`
  width: 100%;
  color: ${({ hasValue, theme }) =>
    hasValue ? theme.colors.black100 : "#b5b3bf"};
  height: 56px;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  padding: 0 30px 0 16px !important;
  appearance: none;
  border-radius: 6px;
  -webkit-appearance: none;
  -mox-appearance: none;
  background-size: 26px 26px;
  background-color: transparent;
  background-image: url(${ImgArrow});
  background-repeat: no-repeat;
  background-position: 95% center;

  &::-ms-expand {
    display: none;
  }

  &:focus {
    outline: none;
    border: 2px solid ${(props) => props.theme.colors.primary100};
  }
`;

export const Placeholder = styled.option`
  color: ${(props) => props.theme.colors.inputPlaceholder};
  font-size: 1.2rem;

  &[value=""] [disabled] {
    display: none;
  }
`;
